import { IPatientWithBaselines } from "../../../@types/admin/AdminBaseline";
import {
  ModalContainer,
  ModalHeader,
  ModalSubtitle,
  ModalTitle,
  PatientBaselinesPanel,
} from "../shared";

interface IPatientBaselinesModalProps {
  patient: IPatientWithBaselines;
}

/**
 * One patient's baselines — Retool's `modalPatientBaselinesInformation`
 * (EN-5168), opened from a row of the patients-with-baselines table.
 *
 * The table itself is the shared `PatientBaselinesPanel`, because the same list
 * appears on the Patients and Archived Patients details screens (EN-5169 /
 * EN-5171). The modal only supplies the heading that names whose baselines
 * these are — Retool's full-screen version said just "Patient Baselines" and
 * left the operator to remember which row they had double-clicked.
 */
export function PatientBaselinesModal({
  patient,
}: IPatientBaselinesModalProps) {
  const patientName = patient.patientName || `Patient ${patient.patientId}`;

  return (
    <ModalContainer>
      <ModalHeader>
        <ModalTitle>Baselines</ModalTitle>
        <ModalSubtitle>
          {patientName} · patient ID {patient.patientId}
          {patient.wardName ? ` · ${patient.wardName}` : ""}
        </ModalSubtitle>
      </ModalHeader>

      <PatientBaselinesPanel patientId={patient.patientId} title={null} />
    </ModalContainer>
  );
}
